import Table from "@/components/Table/table";
import { useParams } from "react-router-dom";
import { useGetClaimAttributeHistoryDataQuery } from "@/services/claimSummary/caseSummaryReducer";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import CustomPagination from "@/components/Pagination/CustomPagination";
import { useEffect, useMemo } from "react";
import { dateFunc } from "@/components/Functions/dateFunc";
import "@/features/creditor/claimsTab/Constant/attributeHistory.scss";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import { useCase } from "@/features/case/use-case";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
export const TitleComplement = () => {
  return <></>;
};

export default function AttributeHistoryTab({ setEditPage }: any) {
  const { t } = useTranslation();
  const { claimId } = useParams<{
    claimId: string;
  }>();
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  let tableLoadingData = customTableLoadingData;
  const retainState = useSelector(
    (e: any) => e.retainState.claimAttributeHistoryTabState
  );
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      ClaimId: claimId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize || paginationPageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  },[claimId, paginationPageSize, retainState]);
  const dispatch = useDispatch();
  const paginationObj = getPaginationObj;
  useEffect(() => {
    setEditPage(false);
  }, [setEditPage]);
  const { data, isLoading, isFetching, error,status } =
    useGetClaimAttributeHistoryDataQuery(paginationObj);
  const sortedData = data?.results ? data?.results : [];
  const headerData = {
    title: "Attribute History X",
    description: "Descriptive text that describes your page or content.",
  };

  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "claimAttributeHistoryTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }

  const caseData = useCase();

  const getColumnHistoryDefs = (timeZone: string) => [
    {
      cellRenderer: "attributeName",
      comparator: () => 0,

      field: "attributeName",
      type: "attributeNameType",
      headerName: t(
        "pages.claims.attributeHistoryTab.tableColumnsDetails.column1"
      ),
      sortable: true,
      unSortIcon: true,
      wrapText: true,
      autoHeight: true,
      flex: 1,
      minWidth: 150,
    },
    {
      comparator: () => 0,

      field: "createdDate",
      type: "createdDateType",
      headerName: t(
        "pages.claims.attributeHistoryTab.tableColumnsDetails.column2"
      ),
      flex: 1,
      minWidth: 150,

      cellRendererParams: {
        timeZoneName: timeZone,
      },
      cellRenderer: function (params: any) {
        return (
          dateFunc(params.data.createdDate).formattedDateTime +
          " " +
          params.timeZoneName
        );
      },
      sortable: true,
      unSortIcon: true,
    },
    {
      comparator: () => 0,

      field: "createdBy",
      type: "createdByType",
      headerName: t(
        "pages.claims.attributeHistoryTab.tableColumnsDetails.column3"
      ),
      flex: 1,
      minWidth: 150,

      sortable: true,
      unSortIcon: true,
    },

    {
      comparator: () => 0,
      field: "oldValue",
      type: "oldValueType",
      headerName: t(
        "pages.claims.attributeHistoryTab.tableColumnsDetails.column4"
      ),
      flex: 1,
      minWidth: 150,
      cellRenderer: function (params: any) {
        return (
          <div style={{ overflowWrap: "anywhere" }} className="text-wrap ">
            {params.data.oldValue || "-"}
          </div>
        );
      },
      wrapText: true,
      autoHeight: true,
      sortable: true,
      unSortIcon: true,
    },
    {
      comparator: () => 0,

      field: "newValue",
      type: "newValueType",
      headerName: t(
        "pages.claims.attributeHistoryTab.tableColumnsDetails.column5"
      ),
      flex: 1,
      minWidth: 150,
      wrapText: true,
      autoHeight: true,
      cellRenderer: function (params: any) {
        return (
          <div style={{ overflowWrap: "anywhere" }} className="text-wrap ">
            {params.data.newValue || "-"}
          </div>
        );
      },
      unSortIcon: true,
    },
  ];
  return (
    <>
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className="mar-b-20">
          <Table
            columnDefs={getColumnHistoryDefs(caseData?.abbreviation)}
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            cellRenderers={isFetching ? [] : sortedData}
            TitleComplement={TitleComplement}
            title={"pages.claims.attributeHistoryTab.title"}
            description={"pages.claims.attributeHistoryTab.description"}
            caseRenderers={headerData}
            pagination={false}
            overlayNoRowsTemplate={
              isFetching
                ? t(tableLoadingData)
                : error
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
            apiData={data}
            apiStatus={status}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!data?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(
                setComponentState1({
                  entityName: "claimAttributeHistoryTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "claimAttributeHistoryTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "claimAttributeHistoryTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      )}
    </>
  );
}
